export default __webpack_public_path__ + "static/media/E-WEB-Goal-09.81355d6f.png";